import { services } from "../../../../constants";
import { token } from "../../../store";

export default async function authInfo() {
  const url = `${this.backendHosts.auth}${services.authInfo}`;
  try {
    const response = await this.http.get(url, await this.getHeaders());
    const spxToken = response?.data?.sessionToken;
    // store spx token in IndexDB
    token.updateSPXToken.call(this, spxToken);
    return response;
  } catch (error) {
    console.log("==> ~ authInfo ~ error:", error);
    this.handleErrorResponse(error);
  }
}
